const SPEECH_RECOGNITION_INPUT_UNSUPPORTED = {
  en: "Voice input is not supported in this browser. You can still type your question.",
  ar: "الإدخال الصوتي غير مدعوم في هذا المتصفح. يمكنك كتابة سؤالك.",
};

const SPEECH_SYNTHESIS_OUTPUT_UNSUPPORTED = {
  en: "Voice output is not supported in this browser.",
  ar: "الردود الصوتية غير مدعومة في هذا المتصفح.",
};

const SPEECH_INPUT_ERROR = {
  en: "Voice input could not start. You can still type your question.",
  ar: "تعذر بدء الإدخال الصوتي. يمكنك كتابة سؤالك.",
};

const SPEECH_INPUT_ERROR_BY_CODE = {
  en: {
    "not-allowed": "Microphone permission is blocked. Allow microphone access and try again.",
    "service-not-allowed": "Microphone permission is blocked. Allow microphone access and try again.",
    "audio-capture": "No microphone is available. Check your microphone and try again.",
    "no-speech": "No speech was detected. Hold the button, speak, then release.",
    network: "Voice recognition is temporarily unavailable. You can still type your question.",
  },
  ar: {
    "not-allowed": "تم حظر إذن الميكروفون. اسمح بالوصول إلى الميكروفون وحاول مرة أخرى.",
    "service-not-allowed": "تم حظر إذن الميكروفون. اسمح بالوصول إلى الميكروفون وحاول مرة أخرى.",
    "audio-capture": "لا يوجد ميكروفون متاح. تحقق من الميكروفون وحاول مرة أخرى.",
    "no-speech": "لم يتم اكتشاف أي كلام. اضغط باستمرار، تحدث، ثم اترك الزر.",
    network: "التعرف على الصوت غير متاح مؤقتا. يمكنك كتابة سؤالك.",
  },
};

export function getSpeechRecognitionLanguage(language = "en") {
  return language === "ar" ? "ar" : "en-US";
}

export function getSpeechSynthesisLanguage(language = "en") {
  return language === "ar" ? "ar" : "en-US";
}

export function getSpeechRecognitionConstructor(scope = getBrowserScope()) {
  if (!scope) return null;
  return scope.SpeechRecognition || scope.webkitSpeechRecognition || null;
}

export function isSpeechRecognitionSupported(scope = getBrowserScope()) {
  return Boolean(getSpeechRecognitionConstructor(scope));
}

export function isSpeechSynthesisSupported(scope = getBrowserScope()) {
  return Boolean(scope?.speechSynthesis && scope?.SpeechSynthesisUtterance);
}

export function getVoiceInputUnsupportedMessage(language = "en") {
  return language === "ar" ? SPEECH_RECOGNITION_INPUT_UNSUPPORTED.ar : SPEECH_RECOGNITION_INPUT_UNSUPPORTED.en;
}

export function getVoiceOutputUnsupportedMessage(language = "en") {
  return language === "ar" ? SPEECH_SYNTHESIS_OUTPUT_UNSUPPORTED.ar : SPEECH_SYNTHESIS_OUTPUT_UNSUPPORTED.en;
}

export function getVoiceInputErrorMessage(language = "en", errorCode = "") {
  const languageKey = language === "ar" ? "ar" : "en";
  return SPEECH_INPUT_ERROR_BY_CODE[languageKey]?.[errorCode] || SPEECH_INPUT_ERROR[languageKey];
}

export function sanitizeVoiceTranscript(transcript = "", maxLength = 500) {
  return String(transcript || "")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, maxLength)
    .trim();
}

export function prepareSpokenAnswer(answer = "") {
  return String(answer || "").trim();
}

export function chooseSpeechSynthesisVoice(scope = getBrowserScope(), language = "en") {
  if (!scope?.speechSynthesis?.getVoices) return null;

  const targetLanguage = getSpeechSynthesisLanguage(language);
  const voices = scope.speechSynthesis.getVoices() || [];
  return (
    voices.find((voice) => String(voice.lang || "").toLowerCase() === targetLanguage.toLowerCase()) ||
    voices.find((voice) => String(voice.lang || "").toLowerCase().startsWith(targetLanguage.slice(0, 2))) ||
    null
  );
}

function getBrowserScope() {
  return typeof window === "undefined" ? null : window;
}
